import {UserGroup} from '../model';

export const GROUP_PRIORITIES: Record<UserGroup, number> = {
  [UserGroup.Superusers]: 10,
  [UserGroup.Owners]: 20,
  [UserGroup.Admins]: 30,
  [UserGroup.Moderators]: 40,
  [UserGroup.EmployeesInventory]: 50,
  [UserGroup.EmployeesRehabilitation]: 55,
  [UserGroup.Employees]: 60,
  [UserGroup.AuthorizedRelatives]: 70,
} as const;
